import { translateText } from "../../../helpers/LanguageHelper";
import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { getLanguageCodeFromSession } from '../../../helpers/CommonHelper';

const WhatsAppFloat = () => {
  const [showMenu, setShowMenu] = useState(false);
  const menuRef = useRef(null);
  const whatsappNumber = '916380413953';
  const message = 'Hello, I have a question on order about butter/ghee';
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;

  useEffect(() => {
    const closeMenu = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) setShowMenu(false);
    };

    document.addEventListener('mousedown', closeMenu);
    return () => document.removeEventListener('mousedown', closeMenu);
  }, []);

  return (
    <div className="ukl-desktop-whatsapp" ref={menuRef}>
      {showMenu && (
        <div className="ukl-desktop-whatsapp__menu" role="menu">
          <a href={whatsappLink} target="_blank" rel="noopener noreferrer" role="menuitem" onClick={() => setShowMenu(false)}>
            <i className="fa fa-comments" />
            <span><strong>{translateText("Chat with us")}</strong><small>{translateText("Questions & support")}</small></span>
          </a>
          <Link to={`/${getLanguageCodeFromSession()}/whatsapp-order`} role="menuitem" onClick={() => setShowMenu(false)}>
            <i className="fa fa-shopping-bag" />
            <span><strong>{translateText("WhatsApp Order")}</strong><small>{translateText("Choose products")}</small></span>
          </Link>
        </div>
      )}
      <button type="button" className="ukl-desktop-whatsapp__trigger" title={translateText("WhatsApp options")} onClick={() => setShowMenu(current => !current)} aria-expanded={showMenu} aria-haspopup="menu">
        <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/1280px-WhatsApp.svg.png?_=20220228223904" alt={translateText("WhatsApp")} />
      </button>
    </div>
  );
};

export default WhatsAppFloat;
